import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { globalErrorHandler } from '../../../utils/GlobalErrorHandler';
import Select from 'react-select';

const NotificationsSend = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [properties, setProperties] = useState([]);
  const [guests, setGuests] = useState([]);
  const [managers, setManagers] = useState([]);
  const [assistantManagers, setAssistantManagers] = useState([]);
  const [overseers, setOverseers] = useState([]);

  const [form, setForm] = useState({
    property_ids: [],
    guest_ids: [],
    manager_ids: [],
    assistant_manager_ids: [],
    overseer_ids: [],
    detail: ''
  });

  const [filtered, setFiltered] = useState({
    guests: [],
    managers: [],
    assistantManagers: [],
    overseers: []
  });

  // Fetch properties on mount
  useEffect(() => {
    fetchProperties();
  }, []);

  const fetchProperties = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-properties`, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      });

      if (res.data.status) {
        const options = res.data.properties.map(p => ({ value: p.id, label: p.property_name }));
        setProperties(options);
      }
    } catch (error) {
      globalErrorHandler(error, navigate);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch guests by role
 

  // Handle property change
const handlePropertiesChange = async (selected) => {
  setForm(prev => ({ ...prev, property_ids: selected }));

  const selectedPropertyIds = selected.map(p => p.value);

  const fetchRole = async (role, setter) => {
    if (!selectedPropertyIds.length) {
      setter([]);
      return;
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-guest-by-role-by-property`,
        { property_ids: selectedPropertyIds, role },
        { withCredentials: true }
      );

      if (res.data.status) {
        const options = res.data.guests.map(g => ({
          value: g.id,
          label: `${g.name} ${g.email}`,
          property_id: g.property_id
        }));
        setter(options);
      } else {
        setter([]);
      }
    } catch (error) {
      globalErrorHandler(error, navigate);
    }
  };

  await Promise.all([
    fetchRole('guest', setGuests),
    fetchRole('manager', setManagers),
    fetchRole('assistant_manager', setAssistantManagers),
    fetchRole('overseer', setOverseers)
  ]);
};



  // Filter based on selected properties
  useEffect(() => {
    const selectedIds = form.property_ids.map(p => p.value);

    const filterByProperty = (list) =>
      list.filter(item => selectedIds.includes(item.property_id));

    setFiltered({
      guests: filterByProperty(guests),
      managers: filterByProperty(managers),
      assistantManagers: filterByProperty(assistantManagers),
      overseers: filterByProperty(overseers)
    });
  }, [form.property_ids, guests, managers, assistantManagers, overseers]);

  const validateForm = () => {
    if (!form.property_ids.length || !form.detail.trim()) {
      Swal.fire("Error", "Property and Notification detail are required.", "error");
      return false;
    }
    return true;
  };

  const sendNotification = async () => {
    if (!validateForm()) return;

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/admin/send-notification`,
        form,
        { withCredentials: true }
      );

      if (res.data.status) {
        Swal.fire("Success", "Notifications sent successfully.", "success");
                navigate('/admin/notifications/list');

        // Optionally reset form here
      } else {
        Swal.fire("Error", res.data.message, "error");
      }
    } catch (error) {
      globalErrorHandler(error, navigate);
    }
  };

  return (
    <div className="container-fluid px-4 mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">Send App Notification</h3>
      </div>

      {!isLoading && (
        <div className="card shadow mt-4">
         
          <div className="card-body p-4">
            <div className="row align-items-end g-4 mb-4">
              <div className="col-md-12">
                <label className="form-label">Select Property <span className="text-danger">*</span></label>
                <Select
                  isMulti
                  name="property_ids"
                  options={properties}
                  value={form.property_ids}
                  onChange={handlePropertiesChange}
                  placeholder="Select Properties"
                  classNamePrefix="react-select"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Select Guest</label>
                <Select
                  isMulti
                  name="guest_ids"
                  options={filtered.guests}
                  value={form.guest_ids}
                  onChange={(selected) => setForm({ ...form, guest_ids: selected })}
                  placeholder="Select Guests"
                  isDisabled={!form.property_ids.length}
                  classNamePrefix="react-select"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Select Overseer</label>
                <Select
                  isMulti
                  name="overseer_ids"
                  options={filtered.overseers}
                  value={form.overseer_ids}
                  onChange={(selected) => setForm({ ...form, overseer_ids: selected })}
                  placeholder="Select Overseers"
                  classNamePrefix="react-select"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Select Manager</label>
                <Select
                  isMulti
                  name="manager_ids"
                  options={filtered.managers}
                  value={form.manager_ids}
                  onChange={(selected) => setForm({ ...form, manager_ids: selected })}
                  placeholder="Select Managers"
                  classNamePrefix="react-select"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Select Assistant Manager</label>
                <Select
                  isMulti
                  name="assistant_manager_ids"
                  options={filtered.assistantManagers}
                  value={form.assistant_manager_ids}
                  onChange={(selected) => setForm({ ...form, assistant_manager_ids: selected })}
                  placeholder="Select Assistant Managers"
                  classNamePrefix="react-select"
                />
              </div>

              <div className="col-md-12">
                <label className="form-label">Notification Detail <span className="text-danger">*</span></label>
                <textarea
                  className="form-control"
                  name="detail"
                  value={form.detail}
                  onChange={(e) => setForm({ ...form, detail: e.target.value })}
                  rows="4"
                />
              </div>

              <div className="col-md-12 mt-3 text-end">
                <button className="btn btn-primary" onClick={sendNotification}>
                  Send Notification
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationsSend;
